import {connect} from 'react-redux';
import React, {Component} from 'react';
import Layout from '../Base/Layout';
import imgFaq from '../../static/img/faq.png';
import {Link} from 'react-router-dom';
import {translate} from '../../utils/i18n'

class HelpPage extends Component {
    constructor(props) {
        super(props);
        this.state = {
            ownerPartActive: false
        };
    }

    render() {
        const i18n = this.props.i18n;
        let {ownerPartActive} = this.state;
        let rows = null;

        if (ownerPartActive) {
            rows = this.props.configuration.help.owner;
        } else {
            rows = this.props.configuration.help.client;
        }

        if(rows == null) {
            rows = [];
        }

        let counter = 0;
        rows = rows.map(e => {
            counter++;
            return (
                <div className="set" key={counter + "client_help"}>
                    <a href="/" onClick={e => {
                        e.preventDefault();
                    }}>
                        <i className="icon-cn icon-default"></i>
                        {e.title}
                    </a>
                    <p>
                        <span dangerouslySetInnerHTML={{__html: e.body}}></span>
                    </p>
                </div>
            )
        });

        let ownerClass = ownerPartActive ? "active" : "";
        let clientClass = !ownerPartActive ? "active" : "";

        return (
            <Layout
                showPromoContent={false}
                title={translate('helpPage.document.title', i18n) !== undefined ? translate('helpPage.document.title', i18n) : ''}
            >
                <div className="clearfix container">
                    <div className="clearfix white_box add_container conv-blc">
                        <Link to="/" className="cancel">{translate("helpPage.back", i18n)}</Link>

                        <div className="clearfix heading">
                            <h2>
                                {translate('helpPage.title', i18n)}
                            </h2>
                        </div>
                        <nav className="i-tab">
                            <a href="" className={ownerClass} onClick={(e) => {
                                e.preventDefault();

                                this.setState({ownerPartActive: true});
                            }}>
                                <i className="icon-tabs"/>
                                {translate('helpPage.forOwner', i18n)}
                            </a>
                            <a href="" className={clientClass} onClick={(e) => {
                                e.preventDefault();

                                this.setState({ownerPartActive: false});
                            }}>
                                <i className="icon-tabs icon-mn"/>
                                {translate('helpPage.forClient', i18n)}
                            </a>
                        </nav>
                        <div className="img-interrogative">
                            <img src={imgFaq} alt=""/>
                        </div>
                        <div className="accordion-box">
                            <div className="accordion-container">
                                {rows}
                            </div>
                            <a href={"mailto:Alexey.vinogoradov@rentamania.es?subject=" + translate('helpPage.emailAgreementSubject', i18n)} className="btn-request">
                                {translate('helpPage.requestAgreement', i18n)}
                            </a>
                        </div>

                    </div>
                </div>
            </Layout>
        )
    }
}


const mapStateToProps = state => ({
    i18n: state.languages.i18n,
    configuration: state.configuration
});

const mapDispatchToProps = {};

export default connect(mapStateToProps, mapDispatchToProps)(HelpPage);



// WEBPACK FOOTER //
// ./src/components/Help/HelpPage.js